import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { Fab, Badge, Tooltip } from '@mui/material';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
// hooks
import useAuth from '../../hooks/useAuth';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

export default function SupportFab() {
    const navigate = useNavigate();
    const { user } = useAuth();
    const [ticketCount, setTicketCount] = useState(0);

    const accessToken = window.localStorage.getItem('accessToken');

    const fetchTickets = useCallback(async () => {
        try {
            if (!accessToken) return;
            const response = await axios.get('/api/admin/support/open-tickets');
            if (response.data.status === 'success') {
                setTicketCount(response.data.tickets.length);
            }
        } catch (error) {
            console.error('Error fetching support tickets:', error);
        }
    }, [accessToken]);

    useEffect(() => {
        fetchTickets();
        const interval = setInterval(fetchTickets, 30000); // Poll every 30s
        return () => clearInterval(interval);
    }, [fetchTickets]);

    const handleClick = () => {
        navigate('/secure/support');
    };

    if (!user || user.type !== 'ADMIN') return null;

    return (
        <Tooltip title={`You have ${ticketCount} open support tickets`} placement="left">
            <Fab
                color="primary"
                aria-label="support"
                onClick={handleClick}
                sx={{
                    position: 'fixed',
                    bottom: 32,
                    right: 32,
                    zIndex: 999,
                    bgcolor: '#2563EB',
                    '&:hover': {
                        bgcolor: '#1E40AF',
                    },
                }}
            >
                <Badge badgeContent={ticketCount} color="error">
                    <HeadsetMicIcon sx={{ color: 'white' }} />
                </Badge>
            </Fab>
        </Tooltip>
    );
}
